import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import { PageHeader } from '../../components/ui/PremiumUI';

const etapas = [
  {
    titulo: '1. Cadastre sua estrutura rural',
    descricao: 'Comece informando o produtor, a fazenda e as áreas onde você produz.',
    links: [
      { label: 'Produtor Rural', path: '/agricultores' },
      { label: 'Fazenda', path: '/propriedades' },
      { label: 'Talhões', path: '/talhoes' },
      { label: 'Mapa da Fazenda', path: '/mapa-fazenda' }
    ]
  },
  {
    titulo: '2. Organize sua primeira safra',
    descricao: 'Crie a safra, escolha os talhões, registre o plantio e prepare os insumos necessários.',
    links: [
      { label: 'Safras', path: '/safras' },
      { label: 'Plantio', path: '/plantios' },
      { label: 'Insumos', path: '/insumos' },
      { label: 'Compra de Insumos', path: '/compras-insumos' }
    ]
  },
  {
    titulo: '3. Registre o trabalho no campo',
    descricao: 'Anote aplicações, operações, despesas e colheitas para acompanhar tudo o que acontece na produção.',
    links: [
      { label: 'Aplicações no Campo', path: '/aplicacoesinsumo' },
      { label: 'Operações de Campo', path: '/operacoes-campo' },
      { label: 'Despesas da Safra', path: '/despesa' },
      { label: 'Colheitas', path: '/colheitas' }
    ]
  },
  {
    titulo: '4. Acompanhe estoque e resultados',
    descricao: 'Controle a produção disponível, registre vendas e veja receitas, despesas e resultado da safra.',
    links: [
      { label: 'Armazém e venda', path: '/producao-agricola' },
      { label: 'Controle Financeiro Agro', path: '/financeiro/controle-agro' },
      { label: 'Fechamento da Safra', path: '/fechamento-safra' },
      { label: 'Exportação bancária', path: '/financeiro/exportacao-bancaria' }
    ]
  },
  {
    titulo: '5. Prepare vendas e documentos',
    descricao: 'Cadastre clientes e transportadoras. Quando precisar emitir documentos, configure o certificado digital.',
    links: [
      { label: 'Clientes', path: '/cliente' },
      { label: 'Transportadoras', path: '/transportadoras' },
      { label: 'Certificado Digital', path: '/configuracoes/certificado' },
      { label: 'Nota Fiscal', path: '/notas-fiscais' },
      { label: 'CT-e / Frete', path: '/cte' }
    ]
  }
];

const resultados = [
  'Sua fazenda e seus talhões organizados em um só lugar.',
  'Safras e plantios separados por área de produção.',
  'Estoque de insumos atualizado a cada compra e aplicação.',
  'Colheitas registradas com a produção disponível para venda.',
  'Receitas e despesas acompanhadas durante toda a safra.',
  'Resultado final com visão de custo, receita e lucro.'
];

function OnboardingInicial() {
  return (
    <>
      <Header />
      <main className="cm-page">
        <PageHeader
          eyebrow="Comece por aqui"
          title="Primeiros passos no CultivaMais"
          description="Siga esta sequência para organizar sua fazenda e começar a usar o sistema no dia a dia."
          actions={(
            <Link className="btn btn-outline-secondary" to="/menu">
              <i className="bi bi-arrow-left me-2" />
              Voltar
            </Link>
          )}
        />

          <div className="row g-3">
            {etapas.map((etapa) => (
              <div className="col-12 col-xl-6" key={etapa.titulo}>
                <section className="cm-surface p-3 h-100">
                  <h5 className="fw-semibold mb-2">{etapa.titulo}</h5>
                  <p className="text-muted mb-3">{etapa.descricao}</p>
                  <div className="d-flex flex-wrap gap-2">
                    {etapa.links.map((link) => (
                      <Link className="btn btn-sm btn-outline-success" to={link.path} key={link.path}>
                        {link.label}
                      </Link>
                    ))}
                  </div>
                </section>
              </div>
            ))}
          </div>

          <section className="cm-surface p-3 mt-4">
            <h5 className="fw-semibold mb-1">Ao concluir estes passos, você terá</h5>
            <p className="text-muted mb-3">Uma visão organizada da fazenda, da produção e dos resultados.</p>
            <div className="row g-2">
              {resultados.map((resultado) => (
                <div className="col-12 col-lg-6" key={resultado}>
                  <div className="d-flex align-items-start gap-2">
                    <i className="bi bi-check-circle-fill text-success mt-1" />
                    <span>{resultado}</span>
                  </div>
                </div>
              ))}
            </div>
          </section>
      </main>
    </>
  );
}

export default OnboardingInicial;
